/**
 * Slick Carousel Initialization
 * Dynamically loads jQuery and Slick, then initializes carousels
 */

(function () {
  'use strict';

  // Wait for jQuery to be available
  function waitForJQuery() {
    return new Promise((resolve) => {
      if (typeof jQuery !== 'undefined') {
        resolve();
        return;
      }

      const checkInterval = setInterval(() => {
        if (typeof jQuery !== 'undefined') {
          clearInterval(checkInterval);
          resolve();
        }
      }, 50);

      // Timeout after 5 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        if (typeof jQuery === 'undefined') {
          console.error('jQuery failed to load');
        }
        resolve();
      }, 5000);
    });
  }

  // Wait for dependencies
  async function loadDependencies() {
    await waitForJQuery();
  }

  function initCarousels($scope) {
    const $ = jQuery;
    const containers = $scope
      ? $scope.find('.carousel-container')
      : $('.carousel-container');

    containers.each(function () {
      const $container = $(this);
      const $slider = $container.find('.carousel-slider');

      // Skip if already initialized
      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      // Fallback: Remove loading state after timeout in case Slick fails
      const loadingTimeout = setTimeout(() => {
        $container.removeClass('carousel-loading').addClass('carousel-loaded');
      }, 3000);

      // Get settings from data attributes
      const autoplay = $container.data('autoplay') === true;
      const autoplaySpeed =
        parseInt($container.data('autoplay-speed'), 10) || 3000;
      const dots = $container.data('dots') === true;
      const arrows = $container.data('arrows') === true;
      const slidesToShow = parseFloat($container.data('slides-to-show')) || 1;
      const slidesToShowMobile =
        parseFloat($container.data('slides-to-show-mobile')) || 1;
      const infinite = $container.data('infinite') === true;
      const responsiveSlides = $container.data('responsive-slides') === true;
      const variableWidth = $container.data('variable-width') === true;
      const fade = $container.data('fade') === true && slidesToShow === 1;
      const peekMobile = $container.data('peek-mobile') || '';
      const variableWidthMobile = $container.data('variable-width-mobile') === true;
      const rows = parseInt($container.data('rows'), 10) || 1;
      const slidesPerRow = parseInt($container.data('slides-per-row'), 10) || 1;

      // Get custom containers for arrows and dots
      const $arrowsContainer = $container.find('.carousel-arrows');
      const $dotsContainer = $container.find('.carousel-dots');

      // Custom arrow buttons with SVG icons
      const prevArrowHtml = `<button type="button" class="carousel-arrow carousel-arrow--prev" aria-label="Previous">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1.4" y="1.4" width="39.199" height="39.199" rx="19.5995" stroke="currentColor" stroke-width="2.8"/>
          <path d="M23.8 28.002V14.002L15.4 21.002L23.8 28.002Z" fill="currentColor"/>
        </svg>
      </button>`;

      const nextArrowHtml = `<button type="button" class="carousel-arrow carousel-arrow--next" aria-label="Next">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1.4" y="1.4" width="39.199" height="39.199" rx="19.5995" stroke="currentColor" stroke-width="2.8"/>
          <path d="M18.1995 28.002V14.002L26.5995 21.002L18.1995 28.002Z" fill="currentColor"/>
        </svg>
      </button>`;

      // Remove loading state after Slick initializes — must be registered before .slick() since init fires during initialization
      $slider.on('init', function () {
        clearTimeout(loadingTimeout);
        $container.removeClass('carousel-loading').addClass('carousel-loaded');

        // Peek-next-slide effect: let .slick-list overflow its bounds so the
        // following slide is partially visible on the right, then clip at the
        // container level so nothing bleeds outside the section.
        if (peekMobile) {
          const id = $container.attr('id');
          const styleEl = document.createElement('style');
          styleEl.setAttribute('data-carousel-peek', id);
          styleEl.textContent = [
            '@media screen and (max-width: 1279px) {',
            '  #' + id + ' { overflow: hidden; }',
            '  #' + id + ' .slick-list {',
            '    overflow: visible !important;',
            '    padding-right: ' + peekMobile + ' !important;',
            '  }',
            '}',
          ].join('\n');
          // Remove any previously injected style for this carousel (theme editor reloads)
          const existing = document.querySelector('[data-carousel-peek="' + id + '"]');
          if (existing) existing.remove();
          document.head.appendChild(styleEl);
        }
      });

      // Initialize Slick
      $slider.slick({
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        dots: dots,
        arrows: arrows,
        prevArrow: prevArrowHtml,
        nextArrow: nextArrowHtml,
        appendArrows: $arrowsContainer,
        appendDots: $dotsContainer,
        slidesToShow: slidesToShow,
        variableWidth: variableWidth,
        rows: rows,
        slidesPerRow: slidesPerRow,
        slidesToScroll: 1,
        infinite: infinite,
        fade: fade,
        cssEase: fade ? 'linear' : 'ease',
        speed: 500,
        pauseOnHover: true,
        pauseOnFocus: true,
        adaptiveHeight: false,
        lazyLoad: 'ondemand',
        responsive: responsiveSlides
          ? [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: Math.max(slidesToShowMobile, slidesToShow - 1),
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: Math.max(slidesToShowMobile, Math.round((slidesToShow + slidesToShowMobile) / 2)),
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: slidesToShowMobile,
                  slidesToScroll: 1,
                },
              },
            ]
          : [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: slidesToShowMobile,
                  slidesToScroll: 1,
                  // variableWidth lets Slick size each slide to match the card's
                  // own width (e.g. 260px) instead of dividing the container.
                  // Required for a correct peek effect with fixed-width cards.
                  variableWidth: variableWidthMobile,
                },
              },
            ],
      });

      // If already initialized (shouldn't happen but just in case)
      if ($slider.hasClass('slick-initialized')) {
        clearTimeout(loadingTimeout);
        $container.removeClass('carousel-loading').addClass('carousel-loaded');
      }
    });
  }

  function observeMenuDrawer() {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('header-menu-drawer-panel').forEach((panel) => {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.attributeName === 'class' &&
            panel.classList.contains('is-visible')
          ) {
            requestAnimationFrame(() => {
              panel.querySelectorAll('.slick-initialized').forEach((slider) => {
                jQuery(slider).slick('refresh');
              });
            });
          }
        }
      }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function observeMegaMenus() {
    document.querySelectorAll('header-mega-menu').forEach((megaMenu) => {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.attributeName === 'open' &&
            megaMenu.hasAttribute('open')
          ) {
            requestAnimationFrame(() => {
              megaMenu
                .querySelectorAll('.slick-initialized')
                .forEach((slider) => {
                  jQuery(slider).slick('refresh');
                });
            });
          }
        }
      }).observe(megaMenu, { attributes: true, attributeFilter: ['open'] });
    });
  }

  // Main init function
  async function init() {
    // Check if there are any carousels on the page
    if (!document.querySelector('.carousel-container')) {
      return;
    }

    await loadDependencies();
    initCarousels();
    observeMenuDrawer();
    observeMegaMenus();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize for Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  }
})();
 